import React from 'react';
import FeatureFlagPopupComponent from './FeatureFlagPopupComponent';
import FormHelperText from '@mui/material/FormHelperText';
const styles = require('../styles.pcss');

interface PlatformSectionProps {
  flagVersions: any;
  checkedItems: string[];
  errorPlatform: string;
  errorFriendlyName: string;
  isLoadingFeatures: boolean;
  onChange: (val: string) => (e: any, checked: boolean) => void;
  onChangeFlagVersion: (type: string, e: any) => void;
  handleClearFlagVersion: (type: string) => void;
  isChecked: (val: string) => boolean;
}

const platforms = [
  { key: 'android', label: 'Android' },
  { key: 'androidUltra', label: 'Android Ultra' },
  { key: 'api', label: 'API' },
  { key: 'ios', label: 'iOS' },
  { key: 'iosUltra', label: 'iOS Ultra' },
  { key: 'web', label: 'Web' },
];

const PlatformSection: React.FC<PlatformSectionProps> = ({
  flagVersions,
  checkedItems,
  errorPlatform,
  errorFriendlyName,
  isLoadingFeatures,
  onChange,
  onChangeFlagVersion,
  handleClearFlagVersion,
  isChecked,
}) => (
  <>
    <div className={styles.informationTitle}>
      <h2>Platforms</h2>
      {errorPlatform && <FormHelperText error>{errorPlatform}</FormHelperText>}
    </div>
    {platforms.map(({ key, label }) => (
      <div
        className={styles.flagPlatformRow}
        key={key}
      >
        <FeatureFlagPopupComponent
          value={flagVersions[key]}
          onChange={onChange(key)}
          error={errorFriendlyName}
          onClear={() => handleClearFlagVersion(key)}
          id={key}
          checked={isChecked(key)}
          onChangeVersion={onChangeFlagVersion}
          disabled={isLoadingFeatures}
          label={label}
        />
      </div>
    ))}
  </>
);

export default PlatformSection;
